// extracted by css-extract-rspack-plugin
export default {"root":"RNIyo7twJGEwFoIx"};